import { BaseText } from '@/src/components/BaseText'
import { appColors } from '@/src/theme'
import { formatDateToDayMonthYear } from '@/src/utils/dateUtil'
import { formatMeasurement } from '@/src/utils/formatMeasurement'
import { Box, Divider, Grid } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import type { LoadPlanningMeasureModalItem } from './LoadPlanningMeasureModal.types'

interface LoadPlanningMeasureModalSummaryTableProps {
  measureItem: LoadPlanningMeasureModalItem
  isCandidate?: boolean
}

export const LoadPlanningMeasureModalSummaryTable = ({ measureItem, isCandidate }: LoadPlanningMeasureModalSummaryTableProps) => {
  const { t, i18n } = useTranslation()

  const tableTemplateColumns = isCandidate ? '26% 26% 46%' : '40% 40% 20%'
  const effectiveFromLabel = measureItem.effectiveFrom ? formatDateToDayMonthYear(new Date(measureItem.effectiveFrom), i18n.language) : '—'

  return (
    <Box borderColor={appColors.border} borderTopWidth='1px' borderBottomWidth='1px' borderLeftWidth='0' borderRightWidth='0' mt='8px'>
      <Grid templateColumns={tableTemplateColumns} px={2} py={2} columnGap={0} borderBottomWidth='2px' borderTopWidth='2px'>
        <BaseText color={appColors.secondaryForeground} fontSize='xs' whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
          {t('components.procurement.forecasting.measure_modal.table.column.designation')}
        </BaseText>
        <BaseText color={appColors.secondaryForeground} fontSize='xs' whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
          {t('components.procurement.forecasting.measure_modal.table.column.effective_from')}
        </BaseText>
        <BaseText color={appColors.secondaryForeground} fontSize='xs' whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
          {isCandidate
            ? t('components.procurement.forecasting.measure_modal.table.column.consumption_delta_candidate')
            : t('components.procurement.forecasting.measure_modal.table.column.consumption_delta_adjustment')}
        </BaseText>
      </Grid>
      <Divider />
      <Grid templateColumns={tableTemplateColumns} px={2} py={3} columnGap={0} alignItems='center'>
        <BaseText color={appColors.black} fontSize='xs'>
          {measureItem?.name ?? '—'}
        </BaseText>
        <BaseText color={appColors.black} fontSize='xs'>
          {effectiveFromLabel}
        </BaseText>
        <BaseText color={appColors.black} fontSize='xs'>
          {(measureItem?.consumptionDelta ?? 0) > 0 ? '+' : ''}
          {formatMeasurement(measureItem?.consumptionDelta, 'kWh')}
        </BaseText>
      </Grid>
    </Box>
  )
}
